import Checkbox from "@visa/vds/checkbox";
import React from "react";
import { useController } from "react-hook-form";
import { FormHelper } from "../_helpers/FormHelper";

function MCSControlCheckbox(props) {
  const { field, fieldState } = useController(props);
  const handleChange = (e) => {
    field.onChange(e.target.checked);
    props.handleChange();
  };
  return (
    <Checkbox
      name={props.name}
      checked={field.value}
      label={props.label}
      onChange={handleChange}
    />
  );
}

export default MCSControlCheckbox;
